import { getGettingStartedSections } from './content/gettingStartedSections';
import { getIntegrationsSections } from './content/integrationsSections';
import { getPublicApiV1Sections } from './content/publicApiV1Sections';
import { getRkeeperSections } from './content/rkeeperSections';
import { getIikoSections } from './content/iikoSections';
import { getYclientsSections } from './content/yclientsSections';
import { getB24Sections } from './content/b24Sections';
import { getAmocrmSections } from './content/amocrmSections';
import { getBookingSections } from './content/bookingSections';
import { getWalletSections } from './content/walletSections';

export const getDocumentationSections = (lang) => [
  ...getGettingStartedSections(lang),
  ...getPublicApiV1Sections(lang),
  ...getIntegrationsSections(lang),
  ...getRkeeperSections(lang),
  ...getIikoSections(lang),
  ...getYclientsSections(lang),
  ...getB24Sections(lang),
  ...getAmocrmSections(lang),
  ...getBookingSections(lang),
  ...getWalletSections(lang),
];
